export const Orientation = {
  All: '',
  Horizontal: 'horizontal',
  Vertical: 'vertical',
  Landscape: 'landscape',
  Portrait: 'portrait'
};